// TOTGA Theme JavaScript

document.addEventListener('DOMContentLoaded', function() {
  // Dynamic Header - Scroll Effect
  const header = document.getElementById('siteHeader');
  let lastScroll = 0;
  let ticking = false;

  function updateHeader() {
    if (!header) return; // Guard clause if header doesn't exist
    
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    if (scrollTop > 10) {
      header.classList.add('scrolled');
      document.body.classList.add('header-scrolled');
    } else {
      header.classList.remove('scrolled');
      document.body.classList.remove('header-scrolled');
    }
    
    lastScroll = scrollTop;
    ticking = false;
  }

  if (header) {
    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(updateHeader);
        ticking = true;
      }
    }, { passive: true });

    // Run on page load
    updateHeader();
  }
  

  // Mobile menu toggle
  const mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
  const mobileMenu = document.getElementById('mobileMenu');
  const mobileMenuOverlay = document.getElementById('mobileMenuOverlay');
  const mobileMenuClose = document.querySelector('.mobile-menu-close');
  
  function openMobileMenu() {
    if (mobileMenu && mobileMenuOverlay) {
      mobileMenu.classList.add('active');
      mobileMenuOverlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    }
  }
  
  function closeMobileMenu() {
    if (mobileMenu && mobileMenuOverlay) {
      mobileMenu.classList.remove('active');
      mobileMenuOverlay.classList.remove('active');
      document.body.style.overflow = '';
    }
  }
  
  if (mobileMenuToggle) {
    mobileMenuToggle.addEventListener('click', openMobileMenu);
  }
  
  if (mobileMenuClose) {
    mobileMenuClose.addEventListener('click', closeMobileMenu);
  }
  
  if (mobileMenuOverlay) {
    mobileMenuOverlay.addEventListener('click', closeMobileMenu);
  }

  // Close menu when clicking a link
  const mobileNavLinks = document.querySelectorAll('.mobile-nav-link');
  mobileNavLinks.forEach(function(link) {
    link.addEventListener('click', closeMobileMenu);
  });

  // Header predictive search panel
  const headerSearch = document.querySelector('.header-search');
  const headerSearchInput = document.getElementById('HeaderSearch');
  const headerSearchPanel = document.getElementById('headerSearchPanel');
  const headerSearchSuggestions = document.getElementById('headerSearchSuggestions');
  const headerSearchProducts = document.getElementById('headerSearchProducts');
  const headerSearchClear = document.querySelector('[data-header-search-clear]');
  let searchDebounce;
  let searchController;

  function escapeHtml(text) {
    return (text || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function showSearchPanel(show) {
    if (!headerSearchPanel) return;
    headerSearchPanel.classList.toggle('active', show);
    headerSearchPanel.setAttribute('aria-hidden', show ? 'false' : 'true');
  }

  function buildSearchSuggestions(term, products) {
    const terms = [];
    products.forEach(product => {
      if (product.title) terms.push(product.title);
    });

    const unique = [...new Set(terms)].slice(0, 6);
    if (unique.length === 0) {
      unique.push(term);
    }
    return unique;
  }

  function renderSearchPanel(term, products) {
    if (!headerSearchSuggestions || !headerSearchProducts) return;

    const suggestions = buildSearchSuggestions(term, products);
    headerSearchSuggestions.innerHTML = suggestions.map((suggestion) => `
      <li>
        <a class="header-search-suggestion-link" href="/search?q=${encodeURIComponent(suggestion)}&type=product">
          ${escapeHtml(suggestion)}
        </a>
      </li>
    `).join('');

    if (!products.length) {
      headerSearchProducts.innerHTML = '<p class="header-search-empty">No matching products found.</p>';
      return;
    }

    headerSearchProducts.innerHTML = products.slice(0, 4).map((product) => `
      <a class="header-search-product" href="${product.url}">
        ${product.image
          ? `<img class="header-search-product-image" src="${product.image}" alt="${escapeHtml(product.title)}" loading="lazy">`
          : '<div class="header-search-product-image"></div>'
        }
        <p class="header-search-product-title">${escapeHtml(product.title)}</p>
      </a>
    `).join('');
  }

  const EXCLUDED_SEARCH_TAGS = ['pair-deal-only', 'pick-mix-only'];

  function isExcludedFromSearch(product) {
    const tags = Array.isArray(product.tags)
      ? product.tags
      : String(product.tags || '').split(',').map((tag) => tag.trim()).filter(Boolean);
    return EXCLUDED_SEARCH_TAGS.some((tag) => tags.includes(tag));
  }

  async function fetchPredictiveSearch(term) {
    if (!term || term.length < 2) {
      showSearchPanel(false);
      return;
    }

    if (searchController) {
      searchController.abort();
    }
    searchController = new AbortController();

    try {
      const response = await fetch(
        `/search/suggest.json?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,vendor`,
        { signal: searchController.signal }
      );
      if (!response.ok) throw new Error('Predictive search request failed');

      const payload = await response.json();
      const products = (payload?.resources?.results?.products || [])
        .filter((product) => !isExcludedFromSearch(product))
        .map((product) => ({
          title: product.title || '',
          url: product.url || '/search?q=' + encodeURIComponent(term),
          image: product.featured_image?.url || ''
        }))
        .filter(product => product.image || product.title);

      renderSearchPanel(term, products);
      showSearchPanel(true);
    } catch (error) {
      if (error.name !== 'AbortError') {
        showSearchPanel(false);
      }
    }
  }

  if (headerSearch && headerSearchInput) {
    headerSearchInput.addEventListener('input', function() {
      const term = this.value.trim();
      headerSearch.classList.toggle('has-value', term.length > 0);

      clearTimeout(searchDebounce);
      searchDebounce = setTimeout(() => {
        fetchPredictiveSearch(term);
      }, 180);
    });

    headerSearchInput.addEventListener('focus', function() {
      const term = this.value.trim();
      if (term.length >= 2) {
        fetchPredictiveSearch(term);
      }
    });

    if (headerSearchClear) {
      headerSearchClear.addEventListener('click', function() {
        headerSearchInput.value = '';
        headerSearch.classList.remove('has-value');
        headerSearchInput.focus();
        showSearchPanel(false);
      });
    }

    document.addEventListener('click', function(event) {
      if (!headerSearch.contains(event.target)) {
        showSearchPanel(false);
      }
    });

    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape') {
        showSearchPanel(false);
      }
    });
  }
  
  // Product thumbnail click handler
  const thumbnails = document.querySelectorAll('.product-thumbnail');
  thumbnails.forEach(function(thumbnail) {
    thumbnail.addEventListener('click', function() {
      thumbnails.forEach(t => t.classList.remove('active'));
      this.classList.add('active');
    });
  });
  
  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const href = this.getAttribute('href');
      if (href !== '#') {
        e.preventDefault();
        const target = document.querySelector(href);
        if (target) {
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }
    });
  });
  
  // Add to cart functionality (disabled in theme editor)
  if (window.Shopify && !window.Shopify.designMode) {
    const addToCartForms = document.querySelectorAll('form[action*="/cart/add"]');
    addToCartForms.forEach(function(form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        
        const formData = new FormData(form);
        const button = form.querySelector('button[type="submit"]');
        if (!button) return;
        
        const originalText = button.textContent;
        
        button.textContent = 'Adding...';
        button.disabled = true;
        
        fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(response => response.json())
        .then(data => {
          button.textContent = 'Added!';
          
          // Update cart count
          fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
              const cartCount = document.querySelector('[data-cart-count]');
              if (cartCount) {
                cartCount.textContent = cart.item_count;
              }
            });
          
          setTimeout(() => {
            button.textContent = originalText;
            button.disabled = false;
          }, 2000);
        })
        .catch(error => {
          console.error('Error adding to cart:', error);
          button.textContent = 'Error - Try Again';
          setTimeout(() => {
            button.textContent = originalText;
            button.disabled = false;
          }, 2000);
        });
      });
    });
  }
  
  // Fade in elements on scroll
  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  };
  
  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('fade-in');
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);
  
  document.querySelectorAll('.product-card, .footer-block').forEach(el => {
    observer.observe(el);
  });
  
  // Update cart count on page load (only in actual store, not theme editor)
  if (window.Shopify && !window.Shopify.designMode) {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartCount = document.querySelector('[data-cart-count]');
        if (cartCount) {
          cartCount.textContent = cart.item_count;
        }
      })
      .catch(error => console.error('Error fetching cart:', error));
  }
});

// Helper function for changing main product image
function changeMainImage(imageUrl) {
  const mainImage = document.getElementById('productMainImage');
  if (mainImage) {
    mainImage.src = imageUrl;
  }
}

// Export for use in templates
window.changeMainImage = changeMainImage;
